import dayjs from 'dayjs'
import { DATE_FORMAT } from './constants'

// 時間格式化
// value:時間, pattern:格式化字串, defaultValue:格式化失敗預設值
// 例 {{ new Date() | timeFormat('YYYY.MM.DD', '-') }}
export function timeFormat (value, pattern = 'YYYY/MM/DD HH:mm', defaultValue = '') {
  if (!value) {
    return defaultValue
  }

  const formatTime = dayjs(value).format(pattern)
  return formatTime === 'Invalid date' ? defaultValue : formatTime
}

// 時間段格式化
export function durationFormat (value, unit = 'seconds', pattern = 'mm:ss') {
  if (!value || !parseInt(value, 10)) {
    value = 0
  }
  return dayjs.duration(value, unit).format(pattern)
}

// 阿拉伯數字轉中文數字
export function numberToZhNum (value) {
  const ZH_NUM_FORMAT = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十']
  const tens = Math.floor(value / 10)
  const digits = value % 10
  return value <= 10 ? ZH_NUM_FORMAT[value - 1] : `${ZH_NUM_FORMAT[tens - 1]}${ZH_NUM_FORMAT[digits - 1]}`
}

// 不同工具入口間跳轉
export function navigateTool (to) {
  window.location.href = `${window.origin}/${to}`
}

/* 轉換物件裡的日期 */
export function transformDateFormat (payload, format = DATE_FORMAT) {
  return Object.keys(payload).reduce((obj, key) => {
    if (payload[key] instanceof Date) {
      obj[key] = dayjs(payload[key]).format(format)
    } else {
      obj[key] = payload[key]
    }

    return obj
  }, {})
}

/* form 表單判斷欄位是否只包含空白或換行符號的驗證器 */
export function emptyContentValidator (rule, value, callback) {
  if (value.trim() === '') {
    return callback(new Error('欄位不能只包含空白或換行符號'))
  }

  return callback()
}
